// Paths the Edge service uses for its own internal endpoints. User-authored
// step routes starting with RESERVED_ROUTE_PREFIX are rejected at commit time
// so adding a new internal route here can never silently shadow someone's step.

const RESERVED_ROUTE_ROOT = "/__3b";

const RESERVED_ROUTE_PREFIX = `${RESERVED_ROUTE_ROOT}/`;

export const HTML_VIEWER_ROUTE = `/__3b/html-viewer`;

export const INTERCOM_ROUTE = `/__3b/intercom`;

export const CHILI_PIPER_ROUTE = `/__3b/chili-piper`;

// Prefixes a draft branch's routes; part of their OAuth token audience (built
// and parsed in oauth/resource.ts).
export const DRAFT_BRANCH_ROUTE_PREFIX = `${RESERVED_ROUTE_ROOT}/branch`;

export function isReservedRoute(route: string): boolean {
  return (
    route === RESERVED_ROUTE_ROOT || route.startsWith(RESERVED_ROUTE_PREFIX)
  );
}
